import React from 'react';
import Button from '@hero/ui-kit/inputs/Button';
import P from '@hero/ui-kit/typography/P';

import { CARE_CODE_LABELS } from '../constants';
import { reportLines } from '../presentation';
import * as Style from '../style.module.scss';
import { CurrentReport } from '../types';
import CareTable from './CareTable';

type Props = { report?: CurrentReport; onCode: (code: string) => void; onReview: () => void };
const BillableByCode: React.FC<Props> = ({ report, onCode, onReview }) => {
    const lines = reportLines(report);
    return (
        <section>
            <div className={Style.reportHeading}>
                <strong>Billable units by code</strong>
                <Button
                    size="small"
                    variant="outlineSecondary"
                    width="natural"
                    noDefaultMargin
                    disabled={!report?.available}
                    onClick={onReview}
                >
                    Needs review: {report?.needs_review_codes ?? '—'} codes
                </Button>
                <P
                    size="small"
                    noDefaultMargin
                >{`Active patients: ${report?.active_patients ?? '—'} · Billable patients: ${report?.billable_patients ?? '—'}`}</P>
            </div>
            <CareTable
                columns={['Program', 'CPT code', 'Billable patients', 'Billable units']}
                gridTemplateColumns="repeat(4, minmax(0, 1fr))"
                loading={!report}
                rows={
                    report
                        ? (lines ?? []).map(([code, line]) => [
                              line.program,
                              <div key="code">
                                  <strong>{code}</strong>
                                  <P size="small" noDefaultMargin>
                                      {CARE_CODE_LABELS.get(code)}
                                  </P>
                              </div>,
                              <Button
                                  key="patients"
                                  size="small"
                                  variant="outlineSecondary"
                                  width="natural"
                                  noDefaultMargin
                                  onClick={() => onCode(code)}
                              >
                                  {line.billable_patients}
                              </Button>,
                              <Button
                                  key="units"
                                  size="small"
                                  variant="outlineSecondary"
                                  width="natural"
                                  noDefaultMargin
                                  onClick={() => onCode(code)}
                              >
                                  {line.billable_units}
                              </Button>
                          ])
                        : undefined
                }
                explanations={[
                    report?.available
                        ? 'Patient totals are distinct. A patient may appear under several codes; do not sum code-row patient counts.'
                        : 'Current totals are unavailable. Select Calculate billable codes to update them.'
                ]}
            />
        </section>
    );
};

export default BillableByCode;
